import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 16,
    padding: '0px 10px 10px 10px',
    },
  text: {
    color: theme.palette.text.primary,
    fontSize: 13,
    margin: 0,
  },
}))

export default useStyles
